import { combineReducers } from 'redux'
import AuthReducer from './reducers/AuthReducer'

export default combineReducers({
    AuthReducer
})